import { useMutation } from '@tanstack/react-query';
import * as api from './index';
import type { CreateInternalRequestDto } from './types';

export const useCreateInternalRequest = () => {
  return useMutation({
    mutationFn: (data: CreateInternalRequestDto) => api.createInternalRequest(data),
  });
};
